/**
 * Date-extensions locale Bulgarian [bg]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('bg', {
    monthNames: ['януари','февруари','март','април','май','юни','юли','август','септември','октомври','ноември','декември'],
    monthShortNames: ['янр','фев','мар','апр','май','юни','юли','авг','сеп','окт','ное','дек'],
    dayNames: ['неделя','понеделник','вторник','сряда','четвъртък','петък','събота'],
    dayShortNames: ['нед','пон','вто','сря','чет','пет','съб']
});
